export default "__VITE_ASSET__CulDZMzZ__"